import React, { useState } from "react";
import styles from "./ClientForm.module.css";

import ClientTopNav from "./ClientTopNav";
import ProgressBar from "./ProgressBar";

// Steps
import PurchaseDetails from "./PurchaseDetails";
import Applicants from "./Applicants";
import Income from "./Income";
import Liabilities from "./Liabilities";
import SummarySubmit from "./SummarySubmit";

export default function ClientFormFlow() {
  const [step, setStep] = useState(1);
  const totalSteps = 5;

  const [formData, setFormData] = useState({
    applicant1: {},
    applicants: [],
    purchase: {},
    income: {},
    liabilities: {},
  });

  const nextStep = () => setStep((s) => Math.min(totalSteps, s + 1));
  const prevStep = () => setStep((s) => Math.max(1, s - 1));

  return (
    <>
      {/* 🔹 Top Navigation */}
      <ClientTopNav />

      {/* 🔹 Flow Container */}
      <div className={styles.clientFlowShell}>
        {/* Progress Bar */}
        <ProgressBar step={step} totalSteps={totalSteps} />

        {/* Step Content */}
        <div className={styles.stepContent}>
          {step === 1 && (
            <PurchaseDetails
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
            />
          )}

          {step === 2 && (
            <Applicants
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              prevStep={prevStep}
            />
          )}

          {step === 3 && (
            <Income
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              prevStep={prevStep}
            />
          )}

          {step === 4 && (
            <Liabilities
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              prevStep={prevStep}
            />
          )}

          {step === 5 && (
            <SummarySubmit
              formData={formData}
              setFormData={setFormData}
              prevStep={prevStep}
            />
          )}
        </div>
      </div>
    </>
  );
}